import React, { useState, FC } from 'react'
import { WithQuestionnaires } from '../questionnaires/QuestionnaireProvider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import I18n from 'i18n'
import Info from '../atomic/atoms/Info'
import classNames from 'classnames'

interface Questionnaires {
  areEnabled: boolean | null | undefined
  oneTimeResponseUrl: (key: string) => string
}

interface Props {
  hideLogboek?: boolean
  withContainer?: boolean
  widerButton?: boolean
  questionnaires?: Questionnaires
}

const SportProLogboekButton: FC<Props> = ({
  hideLogboek = false,
  withContainer = false,
  widerButton = false,
  questionnaires
}) => {
  const [logboekEnabled] = useState(true)

  if (hideLogboek || questionnaires?.areEnabled !== true) {
    return null
  }

  const link = questionnaires.oneTimeResponseUrl('sportpro_wekelijks_logboek')

  const buttonClasses = classNames(
    'waves-effect text-m waves-light button-primary text-primary-color background-background text-medium',
    withContainer && 'button welcome-container-button',
    !withContainer && 'data-button data-detail-page',
    widerButton && 'wider-data-button'
  )

  const Button: FC = () => (
    <a className={buttonClasses} href={link} aria-disabled={!logboekEnabled}>
      <FontAwesomeIcon icon='calendar-week' className='button-icon' />
      {I18n.t('components.welcome.fill_out_sportpro_wekelijks_logboek')}
      <Info
        text={I18n.t('components.welcome.fill_out_sportpro_wekelijks_logboek_tooltip')}
        tooltipId='fill-out-sportpro-logboek-tooltip'
      />
    </a>
  )

  return withContainer
    ? (
      <div className='col s6 m12'>
        <Button />
      </div>
      )
    : (
      <Button />
      )
}

export default WithQuestionnaires(SportProLogboekButton)
